require.register("local-data/assessments/phd-qafeedback-MEX", function(exports, require, module){
  module.exports = {
    "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
    "questions": [
      {
      "id": 1,
      "text": "What should you do?",
      "correct_answer": "B",
      "answers": [
        { "id": "A", 
          "text": "Respond: “Yeah, Sean’s always trying to make a cheap joke. Ignoring him is probably best.”", 
          "correct": false, 
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "B",
          "text": "Respond: “I’m really sorry to hear about this. That was definitely unprofessional, and I can see why you’d be upset.”",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "success feedback"}]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 2,
      "text": "How should Imani respond?",
      "correct_answer": "C",
      "answers": [
        { "id": "A", 
          "text": "“Fernanda, what are you doing? You can’t just say things like that, or touch people however you want. Ashley, you don’t have to put up with that.”", 
          "correct": false, 
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        },
        { "id": "B",
          "text": "Say nothing. Fernanda was just trying to help Ashley through the space and pay her a compliment.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "success feedback"}]
              }]
            }
          }
        },
        { "id": "C", 
          "text": "“Wow, Fernanda. Let’s keep it professional, OK?”", 
          "correct": true, 
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                  "type":"text",
                  "items": [{"description": "failure feedback"}]
              }]
            }
          }
        }
      ]
    },
      {
        "id": 3,
        "text": "What should you do first?",
        "correct_answer": "B",
        "answers": [
          { "id": "A", 
            "text": "Explain to Brent that you know Stacy well, and she’s harmless. He’ll probably be relieved to know she’s not a real threat.", 
            "correct": false, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "success feedback"}]
                }]
              }
            }
          },
          { "id": "B",
            "text": "Tell Brent that what he has just told you is very concerning—unwelcome sexual advances are totally inappropriate at work. Then discuss his options for next steps.",
            "correct": true,
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          },
          { "id": "C", 
            "text": "Tell Brent she’s just flirting. Many of your colleagues would love to have his “problem,” so it can’t be that bad!", 
            "correct": false, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          }
        ]
      },
      {
        "id": 4,
        "text": "What should have been the outcome of this case?",
        "correct_answer": "B",
        "answers": [
          { "id": "A", 
            "text": "The company should have reprimanded Elliot for his conduct toward Kymani, but not for what he said about customers.", 
            "correct": false, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          },
          { "id": "B",
            "text": "The employer should have taken Kymani’s allegations seriously, and addressed them appropriately.",
            "correct": true,
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          }
        ]
      },
      {
        "id": 5,
        "text": "What should have been the outcome of this case?",
        "correct_answer": "B",
        "answers": [
          { "id": "A", 
            "text": "Say, “The consulting firm should have fired both Chance and Shelby to avoid discrimination based on Shelby’s gender.”", 
            "correct": false, 
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "failure feedback"}]
                }]
              }
            }
          },
          { "id": "B",
            "text": "The firm should have taken Shelby’s complaint seriously instead of blaming her for the rumor.",
            "correct": true,
            "feedback": {
              "region": "response",
              "incorrect": {
                "blocks": [{
                    "type":"text",
                    "items": [{"description": "success feedback"}]
                }]
              }
            }
          }
        ]
      }
    ]
  };

  
});

